export default __webpack_public_path__ + "static/media/clientCase7.575bd45e.png";